$(document).ready(function(){


  // milestone presence
  $('.tablinks').click(function(){
    if($(this).hasClass('adtab')){
      $(this).parents('.milestone-wrapper').addClass('milestone-origins');
      $('#milestone-origin').show();
    } else{
      $('#milestone-origin').hide();
      $(this).parents('.milestone-wrapper').removeClass('milestone-origins');
    }
  });
  
  
  var minVale = 0, maxVale = 20; // Set Max and Min values
  // Increase product quantity on cart page
  $(".qty_plus-btn").on('click', function(){
      $(this).siblings('.minus-btn').attr('disabled', false)
      var arrival_input_value = $(this).siblings(".new_arrival_qty_input").val();
      if (arrival_input_value < maxVale) {
          arrival_input_value++;
        $(this).siblings(".new_arrival_qty_input").val(arrival_input_value);
        var arrivalId = $(this).parent().attr('data-valuee-id');
        new_data = {
            "id": arrivalId,
            "quantity": 1
        }
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: new_data,
          dataType: 'json',
          success: function(data) {
            $.getJSON('/cart.js',function(response){
            var count = response.item_count;
            $('.cart-count-bubble').show();
            $('.cart-count-bubble').text(count);
            if (typeof window.syncListingCartFormsFromCart === 'function') {
              window.syncListingCartFormsFromCart(response);
            }
            openCartDrawerAfterAdd();
            // $('#cart-icon-bubble .cart-count-bubble span:last-child').text(count + ' items');  
          });
          },
          error: function() {
            // Do something if there is an error adding the item to cart
            alert('You have added all the available quantity of this product to the cart.');
          }
        });
      }

        
  });
  // Decrease product quantity on cart page
  $(".minus-btnn").on('click', function(){
      var arrival_value = $(this).siblings(".new_arrival_qty_input").val();
      if (arrival_value >= 1) {
        $(this).attr('disabled', false);
        arrival_value--;
      } else if (arrival_value == 0){
        $(this).attr('disabled', true);
      }
      var arvid = $(this).parent().attr('data-valuee-id');
      $(this).siblings(".new_arrival_qty_input").val(arrival_value);
    var new_qtyy = arrival_value;
      arrv_data_remove = {
        "id": arvid,
        "quantity": new_qtyy
      };
      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: arrv_data_remove,
        dataType: 'json',
        success: function(data) {
          $.getJSON('/cart.js',function(response){
            var count = response.item_count;
            $('.cart-count-bubble').show();
            $('.cart-count-bubble').text(count);
            if (typeof window.syncListingCartFormsFromCart === 'function') {
              window.syncListingCartFormsFromCart(response);
            }
            openCartDrawerAfterAdd();
            // $('#cart-icon-bubble .cart-count-bubble span:last-child').text(count + ' items');  
          });
        },
        error: function() {
          // Do something if there is an error removing the item from cart
          alert('Error removing item from cart');
        }
      });
  });


  

    // address delete************************
    $('.del-address').click(function(){
    $(this).find('.loader-btn').show();
    var del_mess = $(this).parents('.adddress-item').find('.confirm-del');
    var form_id = $(this).data('formid');
    var deData = {
     '_method': 'delete'
    };
    var del = $.ajax({
      type: "POST",
      url: '/account/addresses/' + form_id ,
      data: deData,
      dataType: 'html',
      success : function(){
        del_mess.show();
        $('.loader-btn').hide();
        setTimeout(function() { 
          location.reload();
        }, 1000);
      }
    });
      
  });

      // Account edit button
  
$('#edit-address-form').submit(function(eer){
  eer.preventDefault();
  var first_name = $('.fname').val();
  var last_name = $('.lname').val();
  var phone = $('.phone-number').val();
  var company = $('.company').val();
  var zip = $('.Addresszip').val();
  var city = $('.Addresscity').val();
  var province = $('#proedit').val();
  var address = $('.AddressAddress1').val();
  var addreess = $('.AddressAddress2').val();
  var invalid_edit = false;
  var formData = $(this).serialize();
  var url = $(this).attr('action');

  if(first_name.length == 0){
      $(".er-fname-ed").show();
      invalid_edit = true;
    }
  if (phone.length == 0 ) {
      $(".er-phn-ed").show();
      invalid_edit = true;
    } 
  if (zip.length == 0 ) {
      $(".er-zip-ed").show();
      invalid_edit = true;
    } 
  if (city.length == 0 ) {
      $(".er-city-ed").show();
      invalid_edit = true;
    } 
  if (address.length == 0 ) {
      $(".er-add-ed").show();
      invalid_edit = true;
    } 

  if(invalid_edit != true) { 

  var form = this;
  $('.loader-btn',form).show()
  $.ajax({
    url:url,
    type:'POST',
    data:formData,
    success:function(response){
      $('.loader-btn',form).hide();
      $('.edit_address_save .success').show();
      setTimeout(function() { 
          location.reload();
        }, 2000);
    },
    error:function(){
      $('.edit_address_save .error').show();
    }
    
  });
  }
});

   // New Address

  $('#address_form_new').submit(function(ev){
  ev.preventDefault();
    var first_name = $('#AddressFirstNameNew').val();
    var last_name = $('#AddressLastNameNew').val();
    var phone = $('#AddressPhoneNew').val();
    var zip = $('#AddressZipNew').val();
    var city = $('#AddressCityNew').val();
    var province = $('#AddressprovinceNew').val();
    var address = $('#AddressAddress1New').val();
    var address2 = $('#AddressAddress2New').val();
    var invalid_add = false;

    if(first_name.length == 0){
      $(this).find('.er-fname').show();
      invalid_add = true;
    } 
    if(phone.length == 0){
      $(this).find('.er-phn').show();
      invalid_add = true;
    } 
    if(city.length == 0){
      $(this).find('.er-city').show();
      invalid_add = true;
    } 
    if(zip.length == 0){
      $(this).find('.er-zip').show();
      invalid_add = true;
    } 
    if(address.length == 0){
      $(this).find('.er-add').show();
      invalid_add = true;
    } 
    $('#AddressFirstNameNew').keyup(function(){
      $('#address_form_new').find('.er-fname').hide();
    });
    $('#AddressPhoneNew').keyup(function(){
      $('#address_form_new').find('.er-phn').hide();
    });
    $('#AddressCityNew').keyup(function(){
      $('#address_form_new').find('.er-city').hide();
    });
    $('#AddressZipNew').keyup(function(){
      $('#address_form_new').find('.er-zip').hide();
    });
    $('#AddressAddress1New').keyup(function(){
      $('#address_form_new').find('.er-add').hide();
    });
    
    
    if(invalid_add != true){
    var form = this;
    $('.loader-btn',form).show()
    $('#new-address-form .adderror').html('');
    $('#new-address-form .adsuccess').html('');
    $.ajax({
      url:$(form).attr('action'),
      type:'POST',
      data:$(this).serialize(),
      success:function(response){
        $('.loader-btn',form).hide();
        $('#new-address-form .adsuccess').html('Address has been added !!');
        setTimeout(function() { 
            location.reload();
          }, 2000);
      },
      error:function(){
        $('.loader-btn',form).hide();
        $('#new-address-form .adderror').html('Server Error, Please try again');
      }
  });
    }
    
});


 

  
  $('.edit-form-cancel').click(function(){
    $(this).parents('.edit-address').hide();
    $(this).parents('.edit-address').siblings('.adddress-item').show();
    $('body').find('.account-boxed>h2').text('Account Details');
    $('.cancel-button').show();
  });
  
  $('.edit-address-btn').click(function(){
    $(this).parents('.adddress-item').hide();
    $(this).parents('.adddress-item').siblings('.edit-address').show();
    $('body').find('.account-boxed>h2').text('Edit address');
    $('.cancel-button').hide();
  });
  $('.add-new-address').click(function(){
    $('.address-table').hide();
    $('#new-address-form').show();
    $('body').find('.account-boxed>h2').text('Add New Address');
  });
  $('.cancel-form-new').click(function(){
    $('#new-address-form').hide();
    $('.address-table').show();
    $('body').find('.account-boxed>h2').text('Account Details');
  });
  
  $('.view-address').click(function(){
    $(this).parents('.address-table').hide();
    $('#addresss-all').show();
    $('.cancel-button').show();
  });
  $('.cancel-button').click(function(){
    $('#addresss-all').hide();
    $(this).hide();
    $('.address-table').show();
  });
  
  $('.account-btn-primary').click(function(){
    $(this).addClass('account-active');
    $(this).siblings().removeClass('account-active');
  })
  $('#address').click(function(){
    $('body').find('.account-boxed>h2').text('Account Details');
    $('.account-wrapper').find('#dashboard').hide();
    $('.account-wrapper').find('#address').show();
    $('.account-wrapper').find('#orders').hide();
    $('.address-table').show();
    $('#new-address-form').hide();
    $('#addresss-all').hide();
    $('.cancel-button').hide();
  });
  $('#orders').click(function(){
    $('body').find('.account-boxed>h2').text('Orders');
    $('.account-wrapper').find('#dashboard').hide();
    $('.account-wrapper').find('#address').hide();
    $('.account-wrapper').find('#orders').show();
  });
  $('#dashboard').click(function(){
    $('body').find('.account-boxed>h2').text('Dashboard');
    $('.account-wrapper').find('#dashboard').show();
    $('.account-wrapper').find('#address').hide();
    $('.account-wrapper').find('#orders').hide();
  });

  $("#scroller").click(function() {
    $('html, body').animate({
        scrollTop: $("#main-collection-filters").offset().top
    }, 1000);
});
  
  $('.close--menu-drawer').click(function(){
    $('body').removeClass('overflow-hidden-tablet');
  })
  // Ensure all menu items are closed by default on page load
$(document).ready(function () {
    $('.menu-item-child-mobile').hide(); // Hide all child menus
    $('.menuitem-in-mobile').removeClass('active-mob'); // Remove any active class
});

// Handle click event for mobile menu items
$('.menuitem-in-mobile').click(function (e) {
    e.preventDefault(); // Prevent default behavior

    let isActive = $(this).hasClass('active-mob'); // Check if the clicked item is already active

    // Close all other menus and remove active class
    $('.menuitem-in-mobile').removeClass('active-mob');
    $('.menu-item-child-mobile').slideUp();

    // If the clicked menu was not active, open it
    if (!isActive) {
        $(this).addClass('active-mob');
        $(this).siblings('.menu-item-child-mobile').slideDown();
    }
});
  

  $('.menu-hr-block h3').click(function(){
    $(this).toggleClass('menu-active-m');
    $(this).siblings('.collaps-mobile').slideToggle();
    $(this).parent().siblings().children('.collaps-mobile').slideUp();
    $(this).parent().siblings().children('h3').removeClass('menu-active-m');
  });

  // Faq
  $('.hr-question').click(function(){
    $(this).toggleClass('active-ques');
    $(this).parent().siblings().children('.hr-question').removeClass('active-ques');
    $(this).siblings('.hr-answer').slideToggle('linear');
    $(this).parent().siblings().children('.hr-answer').hide();
  });

  
  $('.add-cart-btn').click(function(e){
    e.preventDefault();
    $(this).parents('.btn-group-cart').find('.qty_plus-btn').trigger('click');
    $(this).hide();
    $(this).siblings('.add-btn-hr').show();
    $(this).siblings('.quantity-selctors-hr').show();
  });
  // $('.minus-btn').click(function(){
  //   var qq = $(this).val();
  //   if(qq == 0){
  //     $(this).parent().parent().parent().hide();
  //   }
  // });

  function syncListingCartForm(form) {
    var $form = $(form);
    var $productform = $form.closest('productform.pr-from-add');
    var $btn = $form.find('.primary-add-to-cart');
    var $qty = $form.find('quantity_container.add-cart-quanty');
    var val = parseInt($form.find('.quantity_add_input').val(), 10) || 0;
    if (val > 0) {
      $productform.addClass('is-in-cart');
      $qty.addClass('is-active').css('display', 'inline-flex');
      $btn.hide();
    } else {
      $productform.removeClass('is-in-cart');
      $qty.removeClass('is-active').hide();
      $btn.show();
    }
  }

  function syncNewArrivalCartForm(form) {
    var $form = $(form);
    var val = parseInt($form.find('.new_arrival_qty_input').val(), 10) || 0;
    var $addBtn = $form.find('.add-cart-btn');
    var $qtySelectors = $form.find('.quantity-selctors-hr');
    if (val > 0) {
      $addBtn.hide();
      $qtySelectors.show();
    } else {
      $addBtn.show();
      $qtySelectors.hide();
    }
  }

  function syncPdpQuantityFromCart(cart) {
    $('product-info').each(function () {
      var $info = $(this);
      var $input = $info.find('.quantity__input').first();
      if (!$input.length) return;
      var variantId = $info.find('input.product-variant-id').val() || $input.attr('data-variant-id');
      if (!variantId) return;
      var qty = 0;
      if (cart && cart.items) {
        var line = cart.items.find(function (item) {
          return String(item.variant_id) === String(variantId);
        });
        qty = line ? line.quantity : 0;
      }
      var min = parseInt($input.attr('data-min'), 10) || 1;
      $input.val(qty > 0 ? qty : min);
      $input.attr('data-cart-quantity', qty);
    });
  }

  function getPdpQuantityContext(btn) {
    var $productInfo = $(btn).closest('product-info');
    if (!$productInfo.length) return null;
    var $input = $productInfo.find('.quantity__input').first();
    if (!$input.length) return null;
    var variantId = $productInfo.find('input.product-variant-id').val() || $input.attr('data-variant-id');
    if (!variantId) return null;
    return { $input: $input, variantId: variantId };
  }

  function getPdpCartQty($input) {
    var qty = parseInt($input.attr('data-cart-quantity'), 10);
    return isNaN(qty) ? (parseInt($input.val(), 10) || 0) : qty;
  }

  function pdpMaxQtyTrigger($input) {
    return $('<span>').attr('tinvalue', $input.attr('data-tin') === 'true' ? 'true' : 'false');
  }

  window.syncListingCartFormsFromCart = function(cart) {
    if (!cart) return;
    if (cart.items) {
      $('.product-pick-form').each(function () {
        var variantId = $(this).find('quantity_container.add-cart-quanty').attr('data-value-id');
        if (!variantId) return;
        var line = cart.items.find(function (item) {
          return String(item.variant_id) === String(variantId);
        });
        var qty = line ? line.quantity : 0;
        $(this).find('.quantity_add_input').val(qty);
        syncListingCartForm(this);
      });
      $('form.new-arrival-form-submit').each(function () {
        var variantId = $(this).find('quantity--container.quantity-box').attr('data-valuee-id');
        if (!variantId) return;
        var line = cart.items.find(function (item) {
          return String(item.variant_id) === String(variantId);
        });
        var qty = line ? line.quantity : 0;
        $(this).find('.new_arrival_qty_input').val(qty);
        syncNewArrivalCartForm(this);
      });
    }
    syncPdpQuantityFromCart(cart);
  };

  function showMaxQtyMessage($btn) {
    $('#maxQuantity').addClass('actmes');
    if ($btn && $btn.attr('tinvalue') === 'true') {
      $('.tin-confirm').show();
    }
    setTimeout(function () {
      $('#maxQuantity').removeClass('actmes');
      $('.tin-confirm').hide();
    }, 5000);
  }

  function listingCartApi() {
    return window.HaldiramCart || null;
  }

  function openCartDrawerAfterAdd() {
    if (window.HaldiramCart && typeof window.HaldiramCart.refreshAndOpen === 'function') {
      window.HaldiramCart.refreshAndOpen();
      return;
    }
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.classList.remove('is-empty');
      drawer.open();
    }
  }

  $('.product-pick-form').each(function () {
    syncListingCartForm(this);
  });

  $('form.new-arrival-form-submit').each(function () {
    syncNewArrivalCartForm(this);
  });

  $(document).on('click', '.primary-add-to-cart', function (e) {
    e.preventDefault();
    $(this).closest('.product-pick-form').find('.add-plus').trigger('click');
  });

  $(document).on('click', 'quantity_container.add-cart-quanty .add-plus', function (e) {
    e.preventDefault();
    var $btn = $(this);
    var $input = $btn.siblings('.quantity_add_input');
    var maxVal = parseInt($input.attr('data-max'), 10) || 9999;
    var value = parseInt($input.val(), 10) || 0;
    var variantId = $btn.parent().attr('data-value-id');
    var api = listingCartApi();

    if (!variantId) return;
    if (value >= maxVal) {
      showMaxQtyMessage($btn);
      return;
    }

    $btn.prop('disabled', true);
    $btn.siblings('.minus').prop('disabled', false);

    var nextValue = value + 1;
    $input.val(nextValue);

    var done = function () {
      $btn.prop('disabled', false);
      syncListingCartForm($btn.closest('.product-pick-form')[0]);
      if (nextValue >= maxVal) showMaxQtyMessage($btn);
    };

    if (api && typeof api.addItem === 'function') {
      api.addItem(variantId, 1).then(done).catch(function () {
        $input.val(value);
        showMaxQtyMessage($btn);
        done();
      });
      return;
    }

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: { id: variantId, quantity: 1 },
      dataType: 'json',
      success: function () {
        $.getJSON('/cart.js', function (cart) {
          $('.cart-count-bubble').show();
          if (cart.item_count != null) {
            $('.cart-count-bubble [aria-hidden="true"]').text(cart.item_count);
          }
          if (typeof window.syncListingCartFormsFromCart === 'function') {
            window.syncListingCartFormsFromCart(cart);
          }
          openCartDrawerAfterAdd();
        });
        done();
      },
      error: function () {
        $input.val(value);
        alert('You have added all the available quantity of this product to the cart.');
        done();
      }
    });
  });

  $('.closemaxQty').click(function () {
    $(this).parent().removeClass('actmes');
    $('.tin-confirm').hide();
  });

  $(document).on('click', 'quantity_container.add-cart-quanty .minus', function (e) {
    e.preventDefault();
    var $btn = $(this);
    var $input = $btn.siblings('.quantity_add_input');
    var value = parseInt($input.val(), 10) || 0;
    var variantId = $btn.parent().attr('data-value-id');
    var api = listingCartApi();

    if (!variantId) return;

    if (value <= 0) {
      $btn.prop('disabled', true);
      return;
    }

    var nextValue = value - 1;
    $input.val(nextValue);
    $btn.prop('disabled', nextValue <= 0);

    var done = function () {
      syncListingCartForm($btn.closest('.product-pick-form')[0]);
    };

    if (api && typeof api.setVariantQuantity === 'function') {
      api.setVariantQuantity(variantId, nextValue).then(done).catch(function () {
        $input.val(value);
        if (nextValue > value) showMaxQtyMessage($btn);
        done();
      });
      return;
    }

    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: { id: variantId, quantity: nextValue },
      dataType: 'json',
      success: done,
      error: function () {
        $input.val(value);
        alert('Error updating cart');
        done();
      }
    });
  });

  document.addEventListener('click', function (e) {
    var plusBtn = e.target.closest('product-info .quantity__button[name="plus"]');
    if (plusBtn) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var ctx = getPdpQuantityContext(plusBtn);
      if (!ctx) return;
      var $input = ctx.$input;
      var maxVal = parseInt($input.attr('data-max'), 10) || 9999;
      var value = getPdpCartQty($input);
      var variantId = ctx.variantId;
      var api = listingCartApi();
      var min = parseInt($input.attr('data-min'), 10) || 1;

      if (value >= maxVal) {
        showMaxQtyMessage(pdpMaxQtyTrigger($input));
        return;
      }

      var nextValue = value + 1;
      $input.val(nextValue > 0 ? nextValue : min);
      $input.attr('data-cart-quantity', nextValue);
      $(plusBtn).prop('disabled', true);

      var done = function () {
        $(plusBtn).prop('disabled', false);
        if (nextValue >= maxVal) showMaxQtyMessage(pdpMaxQtyTrigger($input));
      };

      if (api && typeof api.addItem === 'function') {
        api.addItem(variantId, 1).then(done).catch(function () {
          $input.attr('data-cart-quantity', value);
          $input.val(value > 0 ? value : min);
          showMaxQtyMessage(pdpMaxQtyTrigger($input));
          done();
        });
        return;
      }

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: { id: variantId, quantity: 1 },
        dataType: 'json',
        success: function () {
          $.getJSON('/cart.js', function (cart) {
            $('.cart-count-bubble').show();
            if (cart.item_count != null) {
              $('.cart-count-bubble [aria-hidden="true"]').text(cart.item_count);
            }
            if (typeof window.syncListingCartFormsFromCart === 'function') {
              window.syncListingCartFormsFromCart(cart);
            }
            openCartDrawerAfterAdd();
          });
          done();
        },
        error: function () {
          $input.attr('data-cart-quantity', value);
          $input.val(value > 0 ? value : min);
          alert('You have added all the available quantity of this product to the cart.');
          done();
        }
      });
      return;
    }

    var minusBtn = e.target.closest('product-info .quantity__button[name="minus"]');
    if (!minusBtn) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var minusCtx = getPdpQuantityContext(minusBtn);
    if (!minusCtx) return;
    var $minusInput = minusCtx.$input;
    var minusValue = getPdpCartQty($minusInput);
    var minusVariantId = minusCtx.variantId;
    var minusApi = listingCartApi();
    var minusMin = parseInt($minusInput.attr('data-min'), 10) || 1;

    if (minusValue <= 0) return;

    var minusNext = minusValue - 1;
    $minusInput.val(minusNext > 0 ? minusNext : minusMin);
    $minusInput.attr('data-cart-quantity', minusNext);
    $(minusBtn).prop('disabled', minusNext <= 0);

    var minusDone = function () {};

    if (minusApi && typeof minusApi.setVariantQuantity === 'function') {
      minusApi.setVariantQuantity(minusVariantId, minusNext).catch(function () {
        $minusInput.attr('data-cart-quantity', minusValue);
        $minusInput.val(minusValue > 0 ? minusValue : minusMin);
        $(minusBtn).prop('disabled', minusValue <= 0);
      });
      return;
    }

    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: { id: minusVariantId, quantity: minusNext },
      dataType: 'json',
      success: function () {
        $.getJSON('/cart.js', function (cart) {
          if (typeof window.syncListingCartFormsFromCart === 'function') {
            window.syncListingCartFormsFromCart(cart);
          }
        });
      },
      error: function () {
        $minusInput.attr('data-cart-quantity', minusValue);
        $minusInput.val(minusValue > 0 ? minusValue : minusMin);
        alert('Error updating cart');
      }
    });
  }, true);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function () {
      $('product-info').each(function () {
        var $input = $(this).find('.quantity__input').first();
        if (!$input.length) return;
        var cartQty = parseInt($input.attr('data-cart-quantity'), 10) || 0;
        var min = parseInt($input.attr('data-min'), 10) || 1;
        $input.val(cartQty > 0 ? cartQty : min);
      });
    });
  }

  if ($('product-info').length && window.HaldiramCart && typeof window.HaldiramCart.fetchCart === 'function') {
    window.HaldiramCart.fetchCart().then(function (cart) {
      if (typeof window.syncListingCartFormsFromCart === 'function') {
        window.syncListingCartFormsFromCart(cart);
      }
    }).catch(function () {});
  }

  
  // $('.add-cart-btn-pr').click(function(e){
  //   e.preventDefault();
  //   var loader = $(this).children('.loader');
  //   var text = $(this).children('.text-add');
  //   var textcheck = $(this).children('.check');
  //   var fieldid = $(this).attr('data-value-id');
  //   var originalText = ('+');
  //   field_data = {
  //     "id" :  fieldid 
  //   };
  //   console.log(field_data);
  //     var add_to_carts = $.ajax({
  //       type: "POST",
  //       url: '/cart/add',
  //       data: field_data,
  //       beforeSend:     
  //       function() {    
  //         loader.show();
  //         text.hide();
  //       },
  //       success : function(data){
  //         $.getJSON('/cart.js',function(response){
  //           loader.hide();textcheck.show();
  //           setTimeout(function() {
  //             text.show();
  //             textcheck.hide();
  //           }, 2000);
  //           $(this).find('span').show();
  //           $(this).find('span').text('Added');
  //           var count = response.item_count;
  //           $('.cart-count-bubble').show();
  //           $('.cart-count-bubble').text(count);
  //           $("#order-confirm").addClass('addactive');
  //           setTimeout(function() { $("#order-confirm").removeClass('addactive'); }, 3000);
  //           // $('#cart-icon-bubble .cart-count-bubble span:last-child').text(count + ' items');  
  //         });
  //       },
  //       error: function() { // if error occured
  //       alert("You have added the all the available quantity of this product.");
  //       }
  //     });
  // });

 $(document).ready(function(){

  $('.hr-slider-items').slick({
    infinite: false,
    slidesToShow: 5.2,   // avoid decimals on desktop
    slidesToScroll: 3,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 4.2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 3.2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2.2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 641,
        settings: {
          slidesToShow: 2.2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.2,
          slidesToScroll: 1
        }
      }
    ]
  });

  // 🔄 Fix for resize / orientation change
  $(window).on('resize orientationchange', function() {
    $('.hr-slider-items').slick('resize');
  });

});

  $('.recommendation-product').slick({
  infinite: false,
  slidesToShow: 5.2,
  slidesToScroll: 3,
  arrows: true,
    dots: false,
    responsive: [
 {
        breakpoint: 1400,
        settings: {
          slidesToShow: 4.2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 3.2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2.2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 641,
        settings: {
          slidesToShow: 2.2,
          slidesToScroll: 1
        }
      },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1.2,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});



document.addEventListener('DOMContentLoaded', function () {
  $('.discover-slider-wrapper').slick({
    infinite: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: false,
          arrows: true
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: true,
          infinite: false
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: true,
          infinite: false
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          infinite: false
        }
      }
    ]
  });
});


  
  $('.collection-hr-item').slick({
    dots: false,
    infinite: true,
    speed: 300,
    infinite: false,
    slidesToShow: 1.6,
    lazyLoad: 'ondemand',
    adaptiveHeight: false,
    responsive: [
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,

      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
    // add to cart form
  // $('.new-arrival-form-submit').submit(function(e){
  //   e.preventDefault();
  //   var vdata = $(this).serialize();
  //   console.log(vdata);
  // });
$('.add-btn-hr').click(function(e){
      e.preventDefault();
      var fields = $(this).attr('valuee');
      var qqty = $(this).parent().parent().find('.quantity__input').val();
      data = {
        "id": fields,
        "quantity" : qqty
      };
  console.log(data);
      var add_to_cart = $.ajax({
        type: "POST",
        url: '/cart/add',
        data: data,
        dataType: 'json',
        success : function(data){
          $.getJSON('/cart.js',function(response){
            var count = response.item_count;
            $('.cart-count-bubble').show();
            $('.cart-count-bubble').text(count);
            $("#order-confirm").addClass('addactive');
            setTimeout(function() { $("#order-confirm").removeClass('addactive'); }, 3000);
            // $('#cart-icon-bubble .cart-count-bubble span:last-child').text(count + ' items');  
          });
        },
        error: function() { // if error occured
        alert("You have added the all the available quantity of this product.");
        }
      });
    });

  $('.buy-slider').slick({
  dots: false,
  arrows: true,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: false,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

// buy-with

  // buy-with

let isProcessingAddToCart = false;

$('.btn-buy').click(function(e) {
  e.preventDefault();

  if (isProcessingAddToCart) return; // prevent spamming
  isProcessingAddToCart = true;

  const $this = $(this);
  const productId = $this.attr('cardvalue'); // Shopify variant ID
  const hasLimit = $this.attr('data-limit') === 'true'; // only check limit if this is true

  $this.prop('disabled', true); // disable button
  $this.children('.lds-dual-ring').show();

  $.getJSON('/cart.js', function(cart) {
    let currentQtyInCart = 0;

    // Check how many of this product already in cart
    cart.items.forEach(function(item) {
      if (item.id == productId) {
        currentQtyInCart = item.quantity;
      }
    });

    if (hasLimit && currentQtyInCart >= 4) {
      $('#maxQuantity').addClass('actmes');

      if ($this.attr("tinvalue") === 'true') {
        $('.tin-confirm').show();
      }

      setTimeout(function() {
        $('#maxQuantity').removeClass('actmes');
        $('.tin-confirm').hide();
      }, 5000);

      isProcessingAddToCart = false;
      $this.prop('disabled', false);
      $this.children('.lds-dual-ring').hide();
      return;
    }

    // Proceed with add to cart
    const data = { id: productId };

    $this.addClass('hide');

    $.ajax({
      type: "POST",
      url: '/cart/add',
      data: data,
      dataType: 'json',
      success: function() {
        $.getJSON('/cart.js', function(updatedCart) {
          const count = updatedCart.item_count;
          $('.cart-count-bubble').show().text(count);

          $("#order-confirm").addClass('addactive');
          setTimeout(function() {
            $("#order-confirm").removeClass('addactive');
          }, 3000);
        });
      },
      error: function() {
        alert("You have added all the available quantity of this product.");
      },
      complete: function() {
        isProcessingAddToCart = false;
        $this.removeClass('hide');
        $this.children('.lds-dual-ring').hide();
        $this.prop('disabled', false);
      }
    });
  }).fail(function() {
    isProcessingAddToCart = false;
    $this.prop('disabled', false);
    alert("Could not Process the request. Please try again.");
  });
});
  
  // $('.btn-buy').click(function(e){
  //   e.preventDefault();
  //   var max_data = $(this).attr('data-max');
  //   var $this = $(this);
  //   var actualQty = Number($(this).attr('data-cart-total'));
  //   if (actualQty >= max_data){
  //     $('#maxQuantity').addClass('actmes');
  //     if ($this.attr("tinvalue") == 'true'){
  //       $('.tin-confirm').show();
  //     }
  //       setTimeout(function(){
  //       $('#maxQuantity').removeClass('actmes');
  //       $('.tin-confirm').hide();
  //     }, 5000);
  //   } else {
  //         var buy_data = $(this).attr('cardvalue');
  //   data = {
  //     "id" : buy_data
  //   }
  //   console.log(data);
  //   var buy_with_it = $.ajax({
  //       type: "POST",
  //       url: '/cart/add',
  //       data: data,
  //       dataType: 'json',
  //     async:false,
  //       beforeSend:function(){
  //         $(this).addClass('hide');
  //         $(this).children('.lds-dual-ring').show();
  //       },
  //       success : function(){
  //         $.getJSON('/cart.js',function(response){
  //           var newUpdateQty = actualQty + 1;
  //           $this.attr('data-cart-total',newUpdateQty);
  //           var count = response.item_count;
  //           $('.cart-count-bubble').show();
  //           $('.cart-count-bubble').text(count);
  //           $("#order-confirm").addClass('addactive');
  //           setTimeout(function() { $("#order-confirm").removeClass('addactive'); }, 3000);
  //           // $('#cart-icon-bubble .cart-count-bubble span:last-child').text(count + ' items');  
  //         });
  //       },
  //       error: function() { // if error occured
  //       alert("You have added the all the available quantity of this product.");
  //       }
  //     });
  //   }
  // });

  //pdp--page--start---here
 $('.product-pdp-slide').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  dots:false, 
  fade: true,
  responsive: [
  {
      breakpoint: 750,
      settings: {
        dots: true,
        arrows: true,
      }
    }
  ]
});
$('.product-pdp-slide-nav').slick({
  arrows:true,
  slidesToShow: 3,
  dots:false,
  slidesToScroll: 1,
  infinite: true,
  asNavFor: '.product-pdp-slide',
  focusOnSelect: true,
  verticalSwiping:true,
  vertical: true
});
$('.product-pdp-slide-nav .slick-slide').on('click', function (event) {
   $('.product-pdp-slide').slick('slickGoTo', $(this).data('slickIndex'));
});

  $('.recover-btn').click(function(){
    $('.recover-acc').show();
    $('.login-acc').hide();
  });
  if (window.location.href.indexOf("#recover") > -1) {
      $('.recover-acc').show();
      $('.login-acc').hide();
  } else {
    $('.recover-acc').hide();
  }
  if (window.location.href.indexOf("#login") > -1) {
      $('.recover-acc').hide();
    $('.login-acc').show();
  }
  $('.log-cancel').click(function(){
    $('.recover-acc').hide();
    $('.login-acc').show();
  });

  $('.reset-form-validation').click(function(e){
      var email_value = $('.reset-email').val();
      if(email_value.length == 0 || email_value == null ){
        $('.reset-emp-error').show();
        e.preventDefault();
      }
    });

$('.signin-form-validation').click(function(e){
      var email_value = $('.email-info').val();
     var pass_value = $('.passlogin').val();
      if(email_value.length == 0 || email_value == null ){
        $('.login-emp-error').show();
        e.preventDefault();
      }
      if(pass_value.length == 0 ){
        $('.login-pass-emp').show();
        e.preventDefault();
      }
    });

  $('.email-info').click(function(){
      $('.login-emp-error').hide();
    });
$('.passlogin').click(function(){
      $('.login-pass-emp').hide();
    });
  $('.reset-email').click(function(){
      $('.reset-emp-error').hide();
    });

  $('.form-register').click(function(e){
    var email_reg_value = $('.email-register').val();
    var fname_reg_value = $('.fname').val();
    var lname_reg_value = $('.lname').val();
    var password = $('.passreg').val();
    var invalid = false;
    $('.err-field').hide();
    if(email_reg_value.length == 0 || email_reg_value == null ){
        $('.email-emp-error').show();
      invalid = true;
        //e.preventDefault();
    } 
    if(fname_reg_value.length == 0) {
      $('.fname-emp-error').show();
      invalid = true;
      //e.preventDefault();
    } 
    if(password.length == 0) {
      $('.pass-emp-error').show();
      invalid = true;
      //e.preventDefault();
    } 
    if( password.length > 0  && password.length < 4) {
      $('.pass-emp-error').hide();
      $('.pass-emp-val').show();
      invalid = true;
      //e.preventDefault();
    }
    if(invalid === true){
      e.preventDefault();
    }
  });
  $('.fname').click(function(){
      $('.fname-emp-error').hide();
    });
$('.email-register').click(function(){
      $('.email-emp-error').hide();
    });
  $('.passreg').click(function(){
      $('.pass-emp-error').hide();
    });

  $('.contact-submit').click(function(e){
    var c_name = $('#ContactForm-name').val();
    var c_email = $('#ContactForm-email').val();
    var c_phn = $('#ContactForm-phone').val();
    var c_mess = $('#ContactForm-body').val();
    var c_type = $('#country').val();
    if(c_name.length == 0 || c_name == null ){
        $('.c_name-error').show();
        e.preventDefault();
      }
    if(c_email.length == 0 || c_email == null ){
        $('.conatct-emp-error').show();
        e.preventDefault();
      }
    if(c_phn.length == 0 || c_phn == null ){
        $('.phone-emp-error').show();
        e.preventDefault();
      }
    if(c_mess.length == 0 || c_mess == null ){
        $('.content-emp-error').show();
        e.preventDefault();
      }
    if(c_type == "" || c_type == null ){
        $('.sel-emp-error').show();
        e.preventDefault();
      }
    
  });
  $('#ContactForm-name').click(function(){
      $('.c_name-error').hide();
    });
  $('#ContactForm-email').click(function(){
      $('.conatct-emp-error').hide();
    });
  $('#ContactForm-phone').click(function(){
      $('.phone-emp-error').hide();
    });
  $('#country').click(function(){
      $('.sel-emp-error').hide();
    });
  $('#ContactForm-body').click(function(){
      $('.content-emp-error').hide();
    });


$('.instantBuy').click(function (e){
   e.preventDefault();
   var formParams = $(this).attr('data-id');
  var dataQty = $('quantity-input').find('.quantity__input').val();
    data = {
      "id" : formParams,
      "quantity" : dataQty
    }
   $.ajax({
    url: "/cart/add",
    type: "POST",
    data: data,
     dataType: "json",
    success: function(){ 
     window.location.href = "/checkout";
    },
    error: function(){
    }
   });
 });

$(document).on("click", ".cart-inc", function(e){
    var cartItemVal = $(this).siblings('.quantity__input').val();
    var cartItemMax = parseInt($(this).siblings('.quantity__input').attr('data-max'));
    var cartTinVal = $(this).attr('tinvalue');
    if(cartItemVal >= cartItemMax && cartTinVal == 'false'){
      $('#maxQuantity').addClass('actmes');
      setTimeout(function(){
        $('#maxQuantity').removeClass('actmes');
        $('.tin-confirm').hide();
      }, 5000);
    } else if (cartItemVal >= cartItemMax && cartTinVal == 'true'){
      $(this).attr('disabled',true)
      $('#maxQuantity').addClass('actmes');
      $('.tin-confirm').show();
      setTimeout(function(){
        $('#maxQuantity').removeClass('actmes');
        $('.tin-confirm').hide();
      }, 5000);
    } else {
      $('#maxQuantity').removeClass('actmes');
      $('.tin-confirm').hide();
    }
});



});
  function onlyNumberKey(s){
    var e=s.which?s.which:s.keyCode;
    return!(e>31&&(e<48||e>57))
  }


/* =========================================
   GLOBAL TIN SWEETS VALIDATION
   Safe lightweight hardening layer
========================================= */
// (function () {
//   const TIN_LIMIT = 4;
//   async function getCart() {
//     try {
//       const response = await fetch('/cart.js');
//       return await response.json();
//     } catch (e) {
//       console.log('Cart validation failed');
//       return null;
//     }
//   }
//   function isTinProduct(item) {
//     if (!item) return false;
//     if (
//       item.product_tags &&
//       item.product_tags.includes('tin-sweets-limit')
//     ) {
//       return true;
//     }
//     return false;
//   }
//   async function validateTinLimits() {
//     const cart = await getCart();
//     if (!cart) return true;
//     let invalid = false;
//     cart.items.forEach(function(item) {
//       if (
//         isTinProduct(item) &&
//         item.quantity > TIN_LIMIT
//       ) {
//         invalid = true;
//       }
//     });
//     toggleCheckoutButtons(!invalid);
//     return !invalid;
//   }
//   function toggleCheckoutButtons(enable) {
//     const buttons = document.querySelectorAll(
//       '[name="checkout"], .shopify-payment-button button'
//     );
//     buttons.forEach(function(btn) {
//       btn.disabled = !enable;
//       if (!enable) {
//         btn.style.pointerEvents = 'none';
//         btn.style.opacity = '0.5';
//       } else {
//         btn.style.pointerEvents = '';
//         btn.style.opacity = '';
//       }
//     });
//   }
//   async function handleValidationFailure() {
//     $('#maxQuantity').addClass('actmes');
//     $('.tin-confirm').show();
//     setTimeout(function () {
//       $('#maxQuantity').removeClass('actmes');
//       $('.tin-confirm').hide();
//     }, 5000);
//   }
//   async function interceptCartValidation() {
//     const valid = await validateTinLimits();
//     if (!valid) {
//       handleValidationFailure();
//       throw new Error(
//         'Maximum quantity allowed is 4 per tin sweets product.'
//       );
//     }
//   }
  /* =========================
     INTERCEPT FETCH REQUESTS
  ========================= */
//   const originalFetch = window.fetch;
//   window.fetch = async function (...args) {
//     const url = args[0]?.toString() || '';
//     if (
//       url.includes('/cart/add') ||
//       url.includes('/cart/change') ||
//       url.includes('/cart/update')
//     ) {
//       await interceptCartValidation();
//     }
//     return originalFetch.apply(this, args);
//   };
//   $(document).ready(function () {
//     validateTinLimits();
//   });
// })();

/* =========================================
   BASIC DEVTOOLS / SOURCE CODE DETERRENCE
   Windows + Mac support
========================================= */
// (function () {
//     document.addEventListener('contextmenu', function (e) {
//       e.preventDefault();
//     });
//     document.addEventListener('keydown', function (e) {
//       const key = e.key.toLowerCase();
//       if (e.key === 'F12') {
//         e.preventDefault();
//         return false;
//       }
//       if (e.ctrlKey && e.shiftKey && key === 'i') {
//         e.preventDefault();
//         return false;
//       }
//       if (e.ctrlKey && e.shiftKey && key === 'j') {
//         e.preventDefault();
//         return false;
//       }
//       if (e.ctrlKey && key === 'u') {
//         e.preventDefault();
//         return false;
//       }
//       if (e.metaKey && e.altKey && key === 'i') {
//         e.preventDefault();
//         return false;
//       }
//       if (e.metaKey && e.altKey && key === 'j') {
//         e.preventDefault();
//         return false;
//       }
//       if (e.metaKey && key === 'u') {
//         e.preventDefault();
//         return false;
//       }
//       if (e.metaKey && e.shiftKey && key === 'c') {
//         e.preventDefault();
//         return false;
//       }
//     });
//   })();

/* =========================================
   DEVTOOLS DETECTION + AUTO REFRESH
========================================= */
// (function () {
//   let devtoolsOpen = false;
//   function detectDevTools() {
//     const threshold = 160;
//     const widthDiff =
//       window.outerWidth - window.innerWidth;
//     const heightDiff =
//       window.outerHeight - window.innerHeight;
//     const detected =
//       widthDiff > threshold ||
//       heightDiff > threshold;
//     if (detected && !devtoolsOpen) {
//       devtoolsOpen = true;
//       $('body').css('pointer-events', 'none');
//       alert(
//         'Developer tools detected. Please close Developer Tools.'
//       );
//     }
//     if (!detected && devtoolsOpen) {
//       devtoolsOpen = false;
//       $('body').css('pointer-events', '');
//       location.reload();
//     }
//   }
//   setInterval(detectDevTools, 1000);
// })();

/* =========================================
   PDP "More Offers" coupon carousel (Slick)
   - Initialises only when more than one offer exists
   - Guards against duplicate initialisation
========================================= */
$(document).ready(function () {
  var moreOffersDesktopMq = window.matchMedia('(min-width: 992px)');

  function getMoreOffersSlideCount($track) {
    return $track.children('.pdp-coupon-card').length;
  }

  function isWideOfferCardTrack($track) {
    return $track.closest('.wide_offer_card').length > 0;
  }

  function isMoreOffersDesktopWide() {
    return moreOffersDesktopMq.matches;
  }

  function getMoreOffersMode($track) {
    var slideCount = getMoreOffersSlideCount($track);
    if (slideCount < 2) return 'static';
    if (isWideOfferCardTrack($track) && isMoreOffersDesktopWide()) {
      return slideCount > 2 ? 'wide-desktop' : 'wide-desktop-static';
    }
    return 'default';
  }

  function getMoreOffersSlickOptions(mode) {
    if (mode === 'wide-desktop') {
      return {
        infinite: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: false,
        dots: true
      };
    }
    if (mode === 'default') {
      return {
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true
      };
    }
    return null;
  }

  function destroyMoreOffersCarousel($track) {
    if (!$track.hasClass('slick-initialized')) return;
    try {
      $track.slick('unslick');
    } catch (e) {}
  }

  function initMoreOffersCarousel($track) {
    var mode = getMoreOffersMode($track);
    var currentMode = $track.attr('data-more-offers-mode') || '';

    if (mode === 'static' || mode === 'wide-desktop-static') {
      destroyMoreOffersCarousel($track);
      $track.removeAttr('data-more-offers-mode');
      return;
    }

    var options = getMoreOffersSlickOptions(mode);
    if (!options) return;

    if ($track.hasClass('slick-initialized')) {
      if (currentMode === mode) {
        $track.slick('resize');
        return;
      }
      destroyMoreOffersCarousel($track);
    }

    $track.slick(options);
    $track.attr('data-more-offers-mode', mode);
  }

  function initAllMoreOffersCarousels() {
    $('.pdp-more-offers__track').each(function () {
      initMoreOffersCarousel($(this));
    });
  }

  initAllMoreOffersCarousels();

  var moreOffersResizeTimer;
  $(window).on('resize orientationchange', function () {
    clearTimeout(moreOffersResizeTimer);
    moreOffersResizeTimer = setTimeout(initAllMoreOffersCarousels, 150);
  });

  $(document).on('click', '[data-coupon-copy]', function () {
    var $btn = $(this);
    var code = $btn.attr('data-code') || '';
    if (!code) return;

    var markCopied = function () {
      $btn.addClass('is-copied');
      setTimeout(function () {
        $btn.removeClass('is-copied');
      }, 1500);
    };

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(markCopied).catch(function () {});
      return;
    }

    var $temp = $('<textarea>').val(code).css({ position: 'fixed', opacity: 0 }).appendTo('body');
    $temp[0].select();
    try {
      document.execCommand('copy');
      markCopied();
    } catch (e) {}
    $temp.remove();
  });
});